<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="850px"
      v-bind:body-style="{ height: '300px' }"
    >
    <!-- 表单 -->
    <div >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="客户姓名:" prop="accountName">
              <a-input v-model="searchList.accountName" :allowClear="true" placeholder="请输入客户姓名"/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="身份证号码:" prop="idCard">
              <a-input v-model="searchList.idCard" :allowClear="true" placeholder="请输入身份证号码"/>
            </a-form-model-item>
          </a-col>
     
        </a-row>
        <a-row>
         
          <a-col :span = "12">
            <a-form-model-item label="所属企业:" prop="comId">
              <a-select
                :allowClear="true"
                v-model="searchList.comId"
                placeholder="请选择所属企业"
              >
                <a-select-option v-for="item in qyList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="联系方式:" prop="phoneNo">
              <a-input v-model="searchList.phoneNo" :disabled="this.phoDisabled" :allowClear="true"  placeholder="请输入联系方式"/>
            </a-form-model-item>
          </a-col> 
        </a-row>
        <a-row>
          
          <a-col :span = "12">
            <a-form-model-item label="注册时间:" prop="regDate">
              <a-date-picker v-model="searchList.regDate" :allowClear="true" style="width: 285px;" placeholder="请选择注册时间"/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="渠道:" prop="joinChannel" v-if="disable">
           
              <a-radio-group v-model="searchList.joinChannel" :disabled = "disable">
                    <a-radio value="1">
                      小程序注册
                    </a-radio>
                    <a-radio value="2">
                      手工添加
                    </a-radio>
                  </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
       
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { queryListCompany }  from "@/api/api.js";
export default {
  components: {
  },
  props: {
    modalTitle: {
      type: String,
      default: () => "",
    }, //标题
    memberId:{type:String,  default: () => ""},//会员ID
    data: {
      type: Object,
      default: () => {},
    },//返回信息
  },

  data() {
    return {
      visible: true,
      qyList:[],
      phoDisabled:false,//编辑只读
      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },

      //绑定值
      searchList: {
        accountName: "",//客户姓名
        id: "", //客户编号
        idCard: "",//身份证号码
        comId: "",//所属企业
        phoneNo:"",//联系方式
        regDate: moment(new Date()).format("YYYY-MM-DD"),//注册时间
        joinChannel:''//渠道
      },

      //校验规则
      rules: {
        accountName: [
          {
            required: true,
            message: "客户姓名不能为空！",
            trigger: ["blur",'change'],
          },
          {
            max: 20,
            message: "客户姓名不可超过20字",
            trigger: ["blur",'change'],
          }
        ],
        phoneNo: [
          {
            required: true,
            message: "联系方式不能为空！",
            trigger:["blur",'change'],
          },
          {
            max: 20,
            message: "联系方式不可超过20字",
            trigger: ["blur",'change'],
          }
        ],
        joinChannel:[
        {
            required: true,
            message: "请选择渠道方式",
            trigger:["blur",'change'],
          },
        
        ],
        idCard:[
        {
            max: 20,
            message: "身份证号码不可超过20字",
            trigger: ["blur",'change'],
          }
        ]
      },
      disable:false //是否展示渠道信息
    }
  },

  mounted() {
    queryListCompany({
        pageParam: {
        pageNum: 0,
        pageSize: 0,
        orderBy: ""
      },
      content: {
        comName: "",
        comNo: ""
      }
    }).then(res=>{
      if(res.content.rows[0]){
        res.content.rows.map((item)=>{
          this.qyList.push({'label':item.comName,'value':item.id})
        })
      }
    })
    if (this.modalTitle == "编辑会员信息") {
      this.disable = true;
      this.phoDisabled = true;
      this.searchList = this.data;
      this.searchList.id = this.memberId;
    }
   
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //保存
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if(this.searchList.regDate ==  null){
            this.searchList.regDate = moment(new Date()).format("YYYY-MM-DD");
          }else{
            this.searchList.regDate = moment(this.searchList.regDate).format("YYYY-MM-DD");
          }
          this.$emit("handleOk",this.searchList); 
        }
      });
    },

  },
}
</script>

<style scoped>
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}
</style>
